module.exports = __webpack_public_path__ + "static/media/mail-02.f4d4df69.svg";